import { create } from 'zustand';

interface SidebarState {
  /** 동시에 펼쳐질 수 있는 메뉴 키 목록 (다중 드롭다운 지원). 키는 조상 id를 이어붙인 경로 */
  expandedMenuKeys: string[];
  /** 데스크탑에서 hover로 사이드바가 넓어진 상태 */
  isSidebarExpanded: boolean;
  /** 모바일 드로어 열림 상태 */
  isMobileDrawerOpen: boolean;
  /** 열려 있으면 닫고, 닫혀 있으면 연다 (사용자 클릭용) */
  toggleExpandedMenuKey: (key: string) => void;
  /** 항상 여는 멱등 버전 — effect에서 중복 호출되어도 안전 (사용자 클릭이 아닌 자동 펼침용) */
  expandMenuKey: (key: string) => void;
  setSidebarExpanded: (expanded: boolean) => void;
  setMobileDrawerOpen: (open: boolean) => void;
}

/** 사이드바 열림/메뉴 펼침 상태 */
export const useSidebarStore = create<SidebarState>((set) => ({
  expandedMenuKeys: [],
  isSidebarExpanded: false,
  isMobileDrawerOpen: false,
  toggleExpandedMenuKey: (key) =>
    set((s) => {
      const isOpen = s.expandedMenuKeys.includes(key);
      return { expandedMenuKeys: isOpen ? s.expandedMenuKeys.filter((openKey) => openKey !== key) : [...s.expandedMenuKeys, key] };
    }),
  // 이미 열려 있으면 상태 객체를 그대로 반환해 불필요한 리렌더를 막는다
  expandMenuKey: (key) => set((s) => (s.expandedMenuKeys.includes(key) ? s : { expandedMenuKeys: [...s.expandedMenuKeys, key] })),
  setSidebarExpanded: (expanded) => set({ isSidebarExpanded: expanded }),
  // 드로어와 hover 확장은 별개 상태 — 여기서 isSidebarExpanded를 건드리면
  // 라우트 변경 시 드로어를 닫는 것만으로 데스크탑 사이드바까지 접혀버린다.
  setMobileDrawerOpen: (open) => set({ isMobileDrawerOpen: open }),
}));

/** 패널을 넓게 그려야 하는지 — hover 확장이거나 모바일 드로어가 열린 경우 */
export const selectIsSidebarWide = (s: SidebarState) => s.isSidebarExpanded || s.isMobileDrawerOpen;
